/**
 * 后台接口
 * 2020.12.27
 */

import request from '@/utils/request'
// ----------------登录|退出----------------
/**
 * 登录
 * @param {array} data 请求数据
 */
export function Login(data) {
  return request({
    url: '/admin/account/login',
    method: 'post',
    data: data
  })
}



// ----------------商品分类管理----------------
/**
 * 新增分类
 * @param {array} data 请求参数
 */
export function postGroup(data) {
  return request({
    url: '/admin/group/save',
    method: 'post',
    data: data
  })
}
/**
 * 分类列表
 * @param {array} params 请求数据
 */
export function getGroup(params) {
  return request({
    url: '/admin/group',
    method: 'get',
    params
  })
}
/**
 * 删除分类
 * @param {array} params 请求数据
 */
export function delGroup(params) {
  return request({
    url: '/admin/group/delete',
    method: 'delete',
    params
  })
}
/**
 * 修改分类
 * @param {array} data 请求数据
 */
export function putGroup(data) {
  return request({
    url: '/admin/group/update',
    method: 'put',
    data: data
  })
}

// ----------------图片管理----------------
/**
 * 图片列表
 * @param {array} params 请求数据
 */
export function getImg(params) {
  return request({
    url: '/admin/img',
    method: 'get',
    params
  })
}
/**
 * 删除图片
 * @param {array} params 请求数据
 */
export function delImg(params) {
  return request({
    url: '/admin/img/delete',
    method: 'delete',
    params
  })
}
// 新增图片接口地址为内嵌

// ----------------折扣活动管理----------------
/**
 * 新增活动
 * @param {array} data 请求参数
 */
export function postSales(data) {
  return request({
    url: '/admin/discount/save',
    method: 'post',
    data: data
  })
}
/**
 * 活动列表
 * @param {array} params 请求数据
 */
export function getSales(params) {
  return request({
    url: '/admin/discount',
    method: 'get',
    params
  })
}
/**
 * 删除活动
 * @param {array} params 请求数据
 */
export function delSales(params) {
  return request({
    url: '/admin/discount/delete',
    method: 'delete',
    params
  })
}
/**
 * 修改活动
 * @param {array} data 请求数据
 */
export function putSales(data) {
  return request({
    url: '/admin/discount/update',
    method: 'put',
    data: data
  })
}

// ----------------优惠券----------------
/**
 * 新增优惠券
 * @param {array} data 请求参数
 */
export function postCoupon(data) {
  return request({
    url: '/admin/coupon/save',
    method: 'post',
    data: data
  })
}
/**
 * 优惠券列表
 * @param {array} params 请求数据
 */
export function getCoupon(params) {
  return request({
    url: '/admin/coupon',
    method: 'get',
    params
  })
}
/**
 * 删除优惠券
 * @param {array} params 请求数据
 */
export function delCoupon(params) {
  return request({
    url: '/admin/coupon/delete',
    method: 'delete',
    params
  })
}
/**
 * 修改优惠券
 * @param {array} data 请求数据
 */
export function putCoupon(data) {
  return request({
    url: '/admin/coupon/update',
    method: 'put',
    data: data
  })
}
// ----------------系统设置----------------
/**
 * 全部设置
 * @param {array} params 请求数据
 */
export function getSystem(type) {
  return request({
    url: `/admin/system/${type}`,
    method: 'get'
  })
}
/**
 * 修改设置
 * @param {array} data 请求数据
 */
export function putSystem(data) {
  return request({
    url: '/admin/system/update',
    method: 'put',
    data: data
  })
}
/**
 * 发送测试邮件
 * @param {array} params 请求数据
 */
export function sendEmail(data) {
  return request({
    url: '/admin/system/send_test',
    method: 'post',
    data: data
  })
}

// ----------------轮播图管理----------------
/**
 * 新增轮播图
 * @param {array} data 请求参数
 */
export function postSwipe(data) {
  return request({
    url: '/admin/swipe/save',
    method: 'post',
    data: data
  })
}
/**
 * 轮播图列表
 * @param {array} params 请求数据
 */
export function getSwipe(params) {
  return request({
    url: '/admin/swipe',
    method: 'get',
    params
  })
}
/**
 * 删除轮播图
 * @param {array} params 请求数据
 */
export function delSwipe(params) {
  return request({
    url: '/admin/swipe/delete',
    method: 'delete',
    params
  })
}
/**
 * 修改轮播图
 * @param {array} data 请求数据
 */
export function putSwipe(data) {
  return request({
    url: '/admin/swipe/update',
    method: 'put',
    data: data
  })
}

// ----------------商品管理----------------
/**
 * 新增商品
 * @param {array} data 请求参数
 */
export function postShop(data) {
  return request({
    url: '/admin/goods/save',
    method: 'post',
    data
  })
}
/**
 * 商品列表
 * @param {array} params 请求数据
 */
export function getShop(params) {
  return request({
    url: '/admin/goods',
    method: 'get',
    params
  })
}
/**
 * 商品信息
 * @param {array} params 请求数据
 */
export function getSingleShop(params) {
  return request({
    url: '/admin/goods/read',
    method: 'get',
    params
  })
}
/**
 * 修改状态
 * @param {array} data 请求数据
 */
export function putShopStatus(data) {
  return request({
    url: '/admin/goods/modify',
    method: 'put',
    data: data
  })
}
/**
 * 删除商品及规格
 * @param {array} params 请求数据
 */
export function delShop(params) {
  return request({
    url: '/admin/goods/delete',
    method: 'delete',
    params
  })
}
/**
 * 删除规格
 * @param {array} params 请求数据
 */
export function delNorms(params) {
  return request({
    url: '/admin/goods/delnorms',
    method: 'delete',
    params
  })
}
/**
 * 修改商品
 * @param {array} data 请求数据
 */
export function putShop(data) {
  return request({
    url: '/admin/goods/update',
    method: 'put',
    data
  })
}
/**
 * 修改规格状态
 * @param {array} data 请求数据
 */
export function putNormsStatus(data) {
  return request({
    url: '/admin/goods/norms',
    method: 'put',
    data
  })
}
// ----------------库存管理----------------
/**
 * 新增库存
 * @param {array} data 请求参数
 */
export function postStock(data) {
  return request({
    url: '/admin/stock/save',
    method: 'post',
    data: data
  })
}
/**
 * 库存列表
 * @param {array} params 请求数据
 */
export function getStock(params) {
  return request({
    url: '/admin/stock',
    method: 'get',
    params
  })
}
/**
 * 删除库存
 * @param {array} params 请求数据
 */
export function delStock(params) {
  return request({
    url: '/admin/stock/delete',
    method: 'delete',
    params
  })
}
/**
 * 获取自动发货商品
 * @param {array} params 请求数据
 */
export function getStockShop(params) {
  return request({
    url: '/admin/stock/shop',
    method: 'get',
    params
  })
}

// ----------------首页管理----------------
/**
 * 清理缓存
 * @param {array} params 请求参数
 */
export function getClear(params) {
  return request({
    url: '/admin/home/clear',
    method: 'get',
    params
  })
}

/**
 * 查询数据
 * @param {array} params 请求参数
 */
 export function getHome(params) {
  return request({
    url: '/admin/home',
    method: 'get',
    params
  })
}

/**
 * 订单统计图
 * @param {array} params 请求参数
 */
 export function getLeftChart(params) {
  return request({
    url: '/admin/home/left_chart',
    method: 'get',
    params
  })
}
/**
 * 销量统计图
 * @param {array} params 请求参数
 */
 export function getRightChart(params) {
  return request({
    url: '/admin/home/right_chart',
    method: 'get',
    params
  })
}





// ----------------订单管理----------------
/**
 * 补单
 * @param {array} data 请求参数
 */
export function postSupplement(data) {
  return request({
    url: '/admin/order/supplement',
    method: 'post',
    data: data
  })
}
/**
 * 订单列表
 * @param {array} params 请求数据
 */
export function getOrder(params) {
  return request({
    url: '/admin/order',
    method: 'get',
    params
  })
}
/**
 * 订单统计
 * @param {array} params 请求数据
 */
export function getStatistics(params) {
  return request({
    url: '/admin/order/statistics',
    method: 'get',
    params
  })
}
/**
 * 订单已售统计
 * @param {array} params 请求数据
 */
export function getNormsStatistics(params) {
  return request({
    url: '/admin/order/norms_statistics',
    method: 'get',
    params
  })
}
/**
 * 删除订单
 * @param {array} params 请求数据
 */
export function delOrder(params) {
  return request({
    url: '/admin/order/delete',
    method: 'delete',
    params
  })
}
/**
 * 删除全部未支付订单
 * @param {array} params 请求数据
 */
export function delOrderAll(params) {
  return request({
    url: '/admin/order/delete_all',
    method: 'delete',
    params
  })
}

// ----------------------------------
/**
 * 获取管理员信息
 * @param {array} params 请求数据
 */
 export function getAdmin(params) {
  return request({
    url: '/admin/info',
    method: 'get',
    params
  })
}
/**
 * 修改管理员信息
 * @param {array} data 请求数据
 */
 export function putAdmin(data) {
  return request({
    url: '/admin/info/update',
    method: 'put',
    data
  })
}
/**
 * 获取日志
 * @param {array} params 请求数据
 */
 export function getLog(params) {
  return request({
    url: '/admin/info/log',
    method: 'get',
    params
  })
}


// ----------------------------------
/**
 * 获取更新信息
 * @param {array} params 请求数据
 */
 export function getUpdate(params) {
  return request({
    url: '/admin/update',
    method: 'get',
    params
  })
}


/**
 * 获取收款码
 * @param {array} params 请求数据
 */
 export function getGeekPay(params) {
  return request({
    url: '/admin/geekPay/index',
    method: 'get',
    params
  })
}
/**
 * 删除收款码
 * @param {array} params 请求数据
 */
 export function delGeekPay(params) {
  return request({
    url: '/admin/geekPay/delete',
    method: 'delete',
    params
  })
}

/**
 * 保存收款码
 * @param {array} data 请求数据
 */
 export function postGeekPay(data) {
  return request({
    url: '/admin/geekPay/saves',
    method: 'post',
    data
  })
}

/**
 * 获取配置二维码
 * @param {array} params 请求数据
 */
 export function getQrcode() {
  return request({
    url: '/admin/system/qrcode',
    method: 'post',
  })
}

